<template>
  <div class="modal modal-backdrop">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">
          <i class="fas fa-search me-2"></i>
          検索先設定
          <br />
          <!--<span class="text-danger text-xs ms-4">
            ※同時選択は最大3件…等、条件を記載。
          </span>-->
        </h6>
      </div>
      <div class="modal-body">
        <ul class="list-group mb-3">
          <li
            v-for="(bot, index) in chatbots"
            :key="bot.id || index"
            class="list-group-item list-group-item-action cursor-pointer"
          >
            <div class="form-check d-flex align-items-center">
              <input
                type="checkbox"
                class="form-check-input bulk-select rag-chat me-2"
                :id="'bot-' + bot.id"
                :value="bot"
                :checked="selectedBots.includes(bot.id)"
                @change="toggleBot(bot)"
              />
              <label
                class="form-check-label w-100 cursor-pointer my-1"
                :for="'bot-' + bot.id"
              >
                {{ bot.name }}
              </label>
            </div>
          </li>
        </ul>
      </div>
      <div class="modal-footer">
        <div class="d-flex justify-content-center w-100">
          <button
            class="btn bg-gradient-secondary mb-0 me-3"
            @click="$emit('close')"
          >
            <i class="fas fa-times me-1"></i> 閉じる
          </button>
          <button class="btn bg-gradient-warning mb-0" @click="emitSelections">
            <i class="fas fa-clipboard-check me-1"></i>
            選 択
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    chatbots: {
      type: Array,
      required: false,
      default: () => [],
    },
    initialSelectedBot: {
      type: Object,
      default: null,
    },
  },
  emits: ['close', 'bot-selected'],
  data() {
    return {
      selectedBots: [],
    }
  },
  watch: {
    initialSelectedBot: {
      handler(newVal) {
        this.selectedBots = newVal ? newVal : []
      },
      immediate: true,
    },
  },
  methods: {
    toggleBot(bot) {
      const exists = this.selectedBots.includes(bot.id)
      if (exists) {
        this.selectedBots = this.selectedBots.filter((id) => id !== bot.id)
      } else {
        this.selectedBots.push(bot.id)
      }
    },
    emitSelections() {
      this.$emit('bot-selected', this.selectedBots)
      this.$emit('close')
    },
  },
}
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}
.modal-content {
  background: white;
  border-radius: 0.5rem;
  width: 90%;
  max-width: 400px;
}
</style>
